import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ICON_SIZE} from "../utils";
export enum BUTTON_TYPES {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DANGER = 'danger'
}
export enum BUTTON_STYLES {
  FILLED = 'filled',
  STROKE = 'stroke',
  TEXT = 'text'
}
export enum ICON_POSITION {
  LEFT = 'left',
  RIGHT = 'right'
}

@Component({
  selector: 'beaconstac-button',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss']
})
export class ButtonsComponent {

  BUTTON_TYPES = BUTTON_TYPES;
  BUTTON_STYLES = BUTTON_STYLES;
  ICON_POSITION = ICON_POSITION;


  /**
   * Button style
   */
  @Input()
  style: BUTTON_STYLES = BUTTON_STYLES.FILLED;

  /**
   * Button type
   */
  @Input()
  type: BUTTON_TYPES = BUTTON_TYPES.PRIMARY;

  /**
   * Should button be disabled
   */
  @Input()
  disabled: boolean = false;

  /**
   * Button contents
   *
   * @required
   */
  @Input()
  label = 'Button';

  /**
   * Button icon (font-awesome)
   */
  @Input()
  icon = '';

  /**
   * Button icon position
   */
  @Input()
  iconPosition = ICON_POSITION.LEFT;

  /**
   * custom icon css
   */
  @Input()
  iconSize: ICON_SIZE = ICON_SIZE.MEDIUM;

  /**
   * in case custom icon is required
   */
  @Input()
  useCustomImage: boolean;

  /**
   * Optional click handler
   */
  @Output()
  onClick = new EventEmitter<Event>();

  @Input()
  id: String = '';

  @Input()
  width = '';

  @Input()
  valid = true;

  @Input()
  errorMessage = 'Please enter a valid message';

  @Input()
  isInputGroup = false;


}
